/**
 * Default name pre-filled into the connect form, e.g. "MRPEasy - Fava Cuisine".
 * The business name is omitted until one is chosen rather than rendering a
 * placeholder the user might submit as-is.
 */
export function buildDefaultConnectionName(
  integrationName: string,
  organizationName?: string | null,
): string {
  const org = organizationName?.trim();
  return org ? `${integrationName} - ${org}` : integrationName;
}
